/* src/app/forms/push-pedidos/push-pedidos-stepper/push-pedidos-stepper.component.scss */
.wordwrap {
  width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.main {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  padding: 8px;
}
.divmain {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 6px;
}
.divmainitem {
  width: 24%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px;
  flex-wrap: wrap;
}
.divmain2 {
  width: 100%;
  display: flex;
  gap: 4px;
}
nz-progress {
  flex: 1;
  min-height: 4px;
}
/*# sourceMappingURL=push-pedidos-stepper.component.css.map */
